($ => {

	let formValidator;
	let locationsUtils;
	
	function onSaveLocationQrCode(cb = () => {}) {
		const form = $('.location-form-content');
		formValidator.validateForm(form);
		if (!form.hasClass('has-error')) {

			const field17 = {
				title: $('input[name=title]', form).val(),
				line1: $('input[name=line1]', form).val(),
				line2: $('input[name=line2]', form).val(),
				line3: $('input[name=line3]', form).val(),
			}

			const data = {
				id: form.find('[name="id"]').val(),
				field17: JSON.stringify(field17)
			};
			locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
				if (id != null) {
					form.find('[name="id"]').val(id);
					locationsUtils.showMessage(form, '_success');
					form.find('.add-location-info__client_hidden')
						.removeClass('add-location-info__client_hidden')
						.find('input')
						.val(id);
				} else {
					locationsUtils.showMessage(form, '_server');
				}
				locationsUtils.removeOverlay();
				cb();
			});
		}
	}
	
	function init() {
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;

		$('.btn.submit-location-qr-code-form').on('click', onSaveLocationQrCode);

		$('#qrCodePrinting').click(e => {
			// Save the data
			onSaveLocationQrCode(() => {
					// add the class to the html in order to activate the printing style sheet
					$('html').addClass('qr-code');
					// trigger the print of the page
					window.print();
				});
			});
	};
	
	$(init);

})(jQuery);